import React, { useState } from "react";
import "./admin-management.scss";

const staff = [
  { name: "Admin User", email: "admin@ykmw.com", role: "Super Admin", status: "Active", lastLogin: "Today, 9:20 AM" },
  { name: "Sales Manager", email: "sales@ykmw.com", role: "Manager", status: "Active", lastLogin: "Yesterday, 5:12 PM" },
  { name: "Content Editor", email: "editor@ykmw.com", role: "Editor", status: "Invited", lastLogin: "Pending" },
  { name: "Report Viewer", email: "viewer@ykmw.com", role: "Viewer", status: "Active", lastLogin: "Jun 21, 2026" },
];

const roles = [
  { role: "Super Admin", users: 1, description: "Full access to all modules and system settings." },
  { role: "Manager", users: 3, description: "Manage leads, news, reports and assigned team members." },
  { role: "Editor", users: 2, description: "Create and update news, campaigns and lead notes." },
  { role: "Viewer", users: 6, description: "Read-only access for dashboard and reports." },
];

const permissions = [
  { module: "Dashboard", view: true, create: false, update: false, delete: false },
  { module: "News", view: true, create: true, update: true, delete: false },
  { module: "Leads", view: true, create: true, update: true, delete: true },
  { module: "AI Management", view: true, create: false, update: true, delete: false },
  { module: "Reports", view: true, create: false, update: false, delete: false },
  { module: "Settings", view: true, create: false, update: true, delete: false },
];

const tabs = ["Staff", "Roles", "Permissions"];

const CheckIcon = ({ enabled }) => (
  <span className={`admin-management__permission ${enabled ? "admin-management__permission--yes" : "admin-management__permission--no"}`}>
    {enabled ? "✓" : "—"}
  </span>
);

const AdminManagementPage = () => {
  const [activeTab, setActiveTab] = useState("Staff");

  return (
    <div className="admin-management">
      <section className="admin-management__hero">
        <div>
          <span>Administrative Management</span>
          <h2>Staff, roles & permissions</h2>
          <p>Control user access for YK Channel modules from one place.</p>
        </div>
        <button type="button">+ Invite Staff</button>
      </section>

      <section className="admin-management__summary">
        <article><span>Total Staff</span><strong>12</strong><small>9 active users</small></article>
        <article><span>Roles</span><strong>4</strong><small>Role groups configured</small></article>
        <article><span>Permission Sets</span><strong>24</strong><small>Across 6 modules</small></article>
        <article><span>Pending Invites</span><strong>2</strong><small>Awaiting acceptance</small></article>
      </section>

      <section className="admin-management__panel">
        <div className="admin-management__toolbar">
          <div className="admin-management__tabs">
            {tabs.map((tab) => (
              <button
                key={tab}
                type="button"
                className={activeTab === tab ? "admin-management__tab--active" : ""}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          <input type="search" placeholder={`Search ${activeTab.toLowerCase()}...`} />
        </div>

        {activeTab === "Staff" && (
          <div className="admin-management__table-wrap">
            <table>
              <thead>
                <tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Last Login</th><th>Action</th></tr>
              </thead>
              <tbody>
                {staff.map((person) => (
                  <tr key={person.email}>
                    <td><strong>{person.name}</strong></td>
                    <td>{person.email}</td>
                    <td>{person.role}</td>
                    <td><span className={`admin-management__status admin-management__status--${person.status.toLowerCase()}`}>{person.status}</span></td>
                    <td>{person.lastLogin}</td>
                    <td><button className="admin-management__link-button" type="button">Edit</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === "Roles" && (
          <div className="admin-management__role-grid">
            {roles.map((item) => (
              <article key={item.role}>
                <div>
                  <h3>{item.role}</h3>
                  <span>{item.users} user{item.users > 1 ? "s" : ""}</span>
                </div>
                <p>{item.description}</p>
                <button type="button">Manage Role</button>
              </article>
            ))}
          </div>
        )}

        {activeTab === "Permissions" && (
          <div className="admin-management__table-wrap">
            <table>
              <thead>
                <tr><th>Module</th><th>View</th><th>Create</th><th>Update</th><th>Delete</th></tr>
              </thead>
              <tbody>
                {permissions.map((item) => (
                  <tr key={item.module}>
                    <td><strong>{item.module}</strong></td>
                    <td><CheckIcon enabled={item.view} /></td>
                    <td><CheckIcon enabled={item.create} /></td>
                    <td><CheckIcon enabled={item.update} /></td>
                    <td><CheckIcon enabled={item.delete} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
};

export default AdminManagementPage;
